import React, {Component, Fragment} from "react";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {dateHelper, getFormFieldValue} from "../../Applications/shared/shared";
import {getData, postData} from "../../../api/doLogin";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {checkPerms} from "../../../api/permissions";
import {Player} from "video-react";

export default class RecordingsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preview: null,
    }
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 50,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.accessLevel = 1;
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [2]}}]) ? 2 : this.accessLevel;
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [3]}}]) ? 3 : this.accessLevel;
  }

  reBuildObject(camera_id, dated) {
    var self = this;
    postData(`camera/video/${camera_id}/${dated}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.updateData();
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  getObject(camera_id, dated, type) {
    var self = this;
    getData(`camera/video/${camera_id}/${dated}`, {})
      .then((data) => {
        if (data.status === "Success") {
          self.setState({preview: data.data});
        }
      })
      .catch(error => {
        console.error(error);
      });
    console.log(camera_id, dated, type);
  }

  noteFormatter(cell, row, self) {
    return (
      <Fragment>
        <span>{`${row['display']}`}</span>
        <span>{`${cell}`}</span>
        {/*<Button onClick={(evt) => {*/}
        {/*  setTimeout(() => {*/}
        {/*    const note = window.prompt("Recording Note", cell);*/}
        {/*    if (note !== null) {*/}
        {/*      self.saveNotes(row['camera_id'], row['dated'], note);*/}
        {/*    }*/}

        {/*  }, 10);*/}
        {/*}}>Edit</Button>*/}
      </Fragment>
    );
  }

  actionFormatter(cell, row, self) {
    if (row['status'] === "processing") {
      return "Working...";
    } else if (row['status'] !== "processed" && row['status'] !== "captured") {
      if (self.accessLevel === 3 && row['type'] === "record") {
        return <Button
          onClick={() => {
            this.reBuildObject(row['camera_id'], row['dated']);
          }}
        >Process</Button>
      } else {
        return "Please wait..."
      }
    } else {
      return <Fragment>
        <Button
          onClick={() => {
            this.getObject(row['camera_id'], row['dated'], row['type']);
          }}
        >View</Button>
        {this.accessLevel === 3 && row['type'] === "record" && (
          <Button
            onClick={() => {
              this.reBuildObject(row['camera_id'], row['dated']);
            }}
          >Re-process</Button>
        )}
      </Fragment>
    }
  }

  render() {
    const getType = (type) => {
      switch (type) {
        case "still":
          return "Still Image";
        case "record":
          return "Recording";
        default:
      }
    }
    return <Fragment>
      {!!this.props.recordings &&
        <BootstrapTable data={this.props.recordings} version="4" striped hover pagination search options={this.options}>
          <TableHeaderColumn isKey={true} dataField="id" hidden>Id</TableHeaderColumn>
          <TableHeaderColumn dataField="date_time" dataSort dataFormat={(cell, row) => {
            return cell.split(".")[0].replace("T", " ");
          }}
          >Start Date</TableHeaderColumn>
          <TableHeaderColumn
            dataField="type"
            dataSort
            dataFormat={(cell, row) => getType(cell)}
          >Type</TableHeaderColumn>
          <TableHeaderColumn dataField="status" dataSort>Status</TableHeaderColumn>
          <TableHeaderColumn dataField="notes"
                             dataFormat={(cell, row) => this.noteFormatter(cell, row, this)}>Notes</TableHeaderColumn>
          <TableHeaderColumn dataField="button"
                             dataFormat={(cell, row) => this.actionFormatter(cell, row, this)}
          >Actions</TableHeaderColumn>
        </BootstrapTable>
      }
      <Modal isOpen={this.state.preview !== null}
             className={'modal-lg ' + this.props.className}>
        <ModalHeader>Preview</ModalHeader>
        <ModalBody>
          {this.state.preview && this.state.preview['type'] === "still" && (
            <div>
              <img src={this.state.preview['url']} width="100%" height="100%"/>
            </div>
          )}
          {this.state.preview && this.state.preview['type'] === "record" && (
            <div style={{height: "100%"}}>
              <Player
                playsInline
                src={this.state.preview['url']}
              />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <span>Link expires in 30 minutes</span>
          <Button color="primary"
                  onClick={() => window.open(this.state.preview['url'])}>Download</Button>
          <Button color="secondary"
                  onClick={() => this.setState({preview: null})}>Close</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  }

}



// WEBPACK FOOTER //
// ./src/containers/Leads/views/RecordingsTab.js